import { useMemo } from 'react'
import { jsonTryParse } from '@ztechapps/common.utils'
import map from 'lodash/map'
import { useAppSetting } from '../useAppSettings'

export const useCollaboratorsCompany = (): { collaboratorsCompanyIds: string[] } => {
  const { setting } = useAppSetting({ appSettingKey: 'COLLABORATORS_COMPANY' })

  const collaboratorsCompanyIds = useMemo(() => {
    const parsedValues = jsonTryParse(setting?.value)
    return map(parsedValues, '_id') ?? []
  }, [setting])
  return { collaboratorsCompanyIds }
}
